import {Component, OnInit} from "@angular/core";
import {ActivatedRoute} from "@angular/router";
import {TranslateService} from "@ngx-translate/core";
import { LanguageControllerService } from "../../services/language-controller/language-controller.service";
import {Store} from "../../services/store.service";
import {DeterminantControllerService} from "../../services/registration-controller/determinant-controller.service";

@Component({
    selector: "formio-tabs-section",
    templateUrl: "./formio-tabs-section.component.html",
    styleUrls: ["./formio-tabs-section.component.scss"],
    providers: [],
})
export class FormioTabsSectionComponent implements OnInit {

    public serviceId: string;
    public componentKey: string;
    public componentTabId: string;
    public determinantMapById: { [key: string]: string } = {};

    constructor(private route: ActivatedRoute, public store: Store,
                public determinantService: DeterminantControllerService, public translate: TranslateService,
                private languageService: LanguageControllerService) {
        translate.setDefaultLang(store.state.common.lang);
        languageService.getLanguages().subscribe(
          (data) => {
            translate.addLangs(data.map((l) => l.code));
          });
    }

    public ngOnInit() {
        this.route.params.subscribe((params) => {
            this.serviceId = params.serviceId;
            this.store.state.common.serviceId = params.serviceId;
            this.getServiceDeterminantKeyName();
        });
        this.route.queryParamMap.subscribe((queryParams) => {
            this.componentKey = queryParams.get("key");
            this.componentTabId = queryParams.get("componentTabId");
        });
    }

  public getServiceDeterminantKeyName() {
    this.determinantService.getServiceDeterminantIdAndName(this.serviceId).subscribe(
      (data) => Object.assign(this.determinantMapById, data),
    );
  }

    public sendNrOfTabs(msg: any): void {
        const message = {
          key: this.componentKey,
          count: msg.tabItems.length || 0,
          changes: { componentTabId: msg.componentTabId, tabItemIds: msg.tabItems.map((item) => item.id)},
          submission: msg.tabItems};
        const messageString: string = JSON.stringify(message);
        window.top.postMessage([{channel: "FormBuilder", message: messageString}], "*");
    }

}
